<template>
	<van-tabbar v-if="show" v-model="active" style="z-index:10" active-color="#2f80ed" :border="true" inactive-color="#979799">
		<van-tabbar-item v-for="(k, key) in item" replace :to="k.router" :key="key">
			<span>{{ k.title }}</span>
			<template #icon="props">
				<img :src="props.active ? k.icon.active : k.icon.noactive" :alt="k.title"  />
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			active: 0,
			item: [
				{
					router: '/Home',
					title: "",
					icon: {
						active: '/img/footer/indexed.png',
						noactive: '/img/footer/index.png'
					}
				},
				{
					router: '/Game',
					title: "",
					icon: {
						active: '/img/footer/gameed.png',
						noactive: '/img/footer/game.png'
					}
				},
				{
					router: '/Mine',
					title: "",
					icon: {
						active: '/img/footer/myed.png',
						noactive: '/img/footer/my.png'
					}
				}
			]
		};
	},
	methods: {
    texts(){
      this.item[0].title = this.$t("footer.home");
      this.item[1].title = this.$t("footer.game");
      this.item[2].title = this.$t("footer.mine");
    }
  },
	watch: {
		$route(to) {
			if (to.name == 'home') {
				this.active = 0;
				this.show = true;
			} else if (to.name == 'game') {
				this.active = 1;
				this.show = true;
			} else if (to.name == 'mine') {
				this.active = 2;
				this.show = true;
			} else {
				this.show = false;
			}
      this.texts();
		}
	},
	created() {
    this.texts();
		if (this.$route.name == 'home') {
			this.active = 0;
			this.show = true;
		} else if (this.$route.name == 'game') {
			this.active = 1;
			this.show = true;
		} else if (this.$route.name == 'mine') {
			this.active = 2;
			this.show = true;
		} else {
			this.show = false;
		}
	}
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 55px;
.van-tabbar {
	height: @tabbar-height;
}
.van-tabbar-item__icon img {
	height: @tabbar-img;
}
.van-tabbar-item {
	font-size: 26px;
}
.tui {
	width: 4rem;
	margin-top: -10.333vw;
	background-color: white;
	border-radius: 50%;
	border: 10px solid white;
	z-index: 10;
}
[class*='van-hairline']::after {
	border: none !important;
}
</style>
